/**
 * Close Relic newsletter popup when clicking outside the modal shell.
 * Hooks: [data-newsletter-popup] on the popup, [data-newsletter-popup-shell] on the card.
 */

function bindPopupOutsideClose(popup) {
  if (!popup || popup.dataset.outsideCloseBound === 'true') return;
  popup.dataset.outsideCloseBound = 'true';

  popup.addEventListener('click', function (event) {
    var shell = popup.querySelector('[data-newsletter-popup-shell]');
    if (!shell || shell.contains(event.target)) return;
    if (event.target.closest('dialog-close-button')) return;

    if (typeof popup.hide === 'function') {
      popup.hide();
    }
  });
}

function initPopupOutsideCloseInRoot(root) {
  root.querySelectorAll('[data-newsletter-popup]').forEach(bindPopupOutsideClose);
}

function initRelicNewsletterPopup() {
  initPopupOutsideCloseInRoot(document);
  document.addEventListener('shopify:section:load', function (event) {
    initPopupOutsideCloseInRoot(event.target);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelicNewsletterPopup);
} else {
  initRelicNewsletterPopup();
}
